<template>
  <v-btn class="mt-n2 mr-n1" fab dark small :color="colour" @click="cb()">
    <v-icon>{{ mdi }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    cb: Function,
    mode: {
      type: String,
      default: "add"
    }
  },
  name: "ButtonAdd",
  computed: {
    mdi() {
      return this.mode == "add" ? "mdi-plus" : "mdi-pencil";
    },
    colour() {
      return this.mode == "add" ? "pink" : "#8db993";
    }
  }
};
</script>

<style>
</style>